export default __webpack_public_path__ + "static/2-7421f5e8c67e8598e32df7809603f0fc.png";